<script>
import Layout from "../../../../layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import { useFileStore } from '@/store/fileStore'


import { ref } from "vue";


/**
 * Dashboard Component
 */
export default {
    setup() {
        const doesAddOpen = ref(false);
        const doesEditOpen = ref(false);
        const doesDeleteOpen = ref(false);
        const doesLoadingOpen = ref(false);
                        const fileStore = useFileStore();


        return {
          doesAddOpen,
          doesEditOpen,
          doesDeleteOpen,
          doesLoadingOpen,
                    fileStore

        };
    },
    page: {
    title: "files",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
  },
  data() {
    return {
      title: "files",
      items: [
        {
          text: "Définition",
        },
        {
          text: "files",
          active: true,
        },
      ],
      errors: [],
      file: {},
      files: [],
      users: [],      
      number: "",
      type: "",
      status: "",
      visibility: "",
      user_id: "",
      loading: false,
      statusHttp: 201,
    };
  },
  methods: {
 
    async loadFromStore() {

      if (!this.fileStore.list) {
       await  this.fileStore.loadFromApi(true).then(data => {
        this.files = data
        this.file_search = data
    })
    } else {
        this.files = this.fileStore.list
        this.file_search = this.files
    }

  },

    initItem(file, action="edit") {
      this.file = file
      this.initData(file)
      if (action == "delete") {
        this.doesDeleteOpen = true
      } else {
        this.doesEditOpen = true
      }
    },
    initData(item = null) {
      this.name = item != null ? item.name : ""
      this.type = item != null ? item.type : ""
      this.size = item != null ? item.size : 0
      this.status = item != null ? item.status : 0
      this.entity = item != null ? item.entity : 0
      this.identity = item != null ? item.identity : 0
    },
    getExtension(file) {
      return file.name.split(".").pop().toLowerCase();
    },
    isImage(file) {
      const extensions = ["jpg", "jpeg", "png", "gif"];
      return extensions.includes(this.getExtension(file));
    },
    isPDF(file) {
      return this.getExtension(file) === "pdf";
    },
    isVideo(file) {
      const extensions = ["mp4", "avi", "mov"];
      return extensions.includes(this.getExtension(file));
    },
  },
  mounted() {
    this.loadFromStore()
    this.doesLoadingOpen = false
  },
  watch: {
    doesAddOpen: function() {
      this.errors = []
      if (!this.doesAddOpen) {
        this.initData(null)
      }
    },
    doesEditOpen: function() {
      this.errors = []
      if (!this.doesEditOpen) {
        this.initData(null)
        this.file = null
      }
    },
    doesDeleteOpen: function() {
      if (!this.doesDeleteOpen) {
        this.initData(null)
        this.file = null
      }
    }
  }
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    
    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title">Listes des files</h4>
            <p class="card-title-desc">
              Le tableau ci-dessous présente la listes des <value>files</value>.
            </p>

            <div class="table-responsive">
              <table class="table align-middle mb-0">
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Nom</th>
                    <th>Type</th>
                    <th>Taille</th>
                    <th>Status</th>
                    <th>Entité</th>
                    <th>identity</th>
                    <th>Consulter</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(file, i) in files" :key="file.id">
                    <th scope="row">{{ i + 1 }}</th>
                    <td>
                       <div v-if="isImage(file)">
                          <img :src="file.name" alt="Aperçu image" style="width: 50px; height: auto;" />
                        </div>
                        <div v-else-if="isPDF(file)">
                          <i class="fas fa-file-pdf" style="color: red;"></i> PDF
                        </div>
                        <div v-else-if="isVideo(file)">
                          <video :src="file.name" style="width: 50px; height: auto;" controls></video>
                        </div>
                        <div v-else>
                          <i class="fas fa-file-alt"></i> {{ file.extension.toUpperCase() }}
                        </div>
                        <a :href=" file?.name " target="_blank">{{ file?.name }}</a>
                      </td>
                    <td>{{ file.type }}</td>
                    <td>{{ file.size / 1000 }} ko</td>
                    <td>{{ file.status }}</td>
                    <td>{{ file.entity }}</td>
                    <td>{{ file.identity }}</td>
                    <td class="hstack">
                        <b-button variant="danger" @click="initItem(file, 'delete')" class="ms-2 btn-sm">
                          <i class="bx bx-trash font-size-16 align-middle mx-1"></i>
                        </b-button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            
          </div>
        </div>
      </div>
    </div>

    <!-- LOADING MODAL -->
    <b-modal v-model="doesLoadingOpen" id="modal-center" centered size="md" title="Chargement..."
      title-class="font-18" hide-footer>
      <div class="text-center">
        <div class="spinner-border text-primary-" role="status">
          <span class="visually-hidden">Loading...</span>
        </div>
      </div>
    </b-modal>


    <!-- DELETE MODAL -->
    <b-modal
        v-model="doesDeleteOpen"
        id="modal-center"
        title="Supprimer un file"
        title-class="font-18"
        hide-footer
        >
        <p class="mb-2">
            Voulez-vous vraiment supprimer le file <b>{{ file?.name }}</b> ?
        </p>
        <div class="hstack mt-2" v-if="!loading">
          <button class="btn btn-dark ms-auto" @click="doesDeleteOpen = false">Annuler</button>
          <button class="ms-3 btn btn-danger" @click="deleteIt()">Supprimer</button>
        </div>
        <div class="text-center" v-else>
          <div class="spinner-border text-primary" role="status">
            <span class="visually-hidden">Loading...</span>
          </div>
        </div>
    </b-modal>


  </Layout>
</template>

